import "./index.less";
import React from "react";
import { BasicLayout as AntBasicLayout, PageContainer } from "@ant-design/pro-layout";
import { MenuDataItem } from "@ant-design/pro-layout/lib/typings";
import { Link, useLocation } from "react-router-dom";
import { HomeOutlined, QuestionCircleOutlined, SearchOutlined, TeamOutlined } from "@ant-design/icons";
import Header from "./Header/Header";
// @ts-ignore
import favicon from "./favicon.ico";

interface BasicLayoutProps {}

const isNew = <span style={{ color: "red" }}> New</span>;

const route: MenuDataItem = {
  routes: [
    {
      path: "/",
      name: "电子面单",
      icon: <HomeOutlined />,
      routes: [
        {
          name: "我的面单账号",
          path: "/ewaybillAccount",
        },
        {
          name: "我共享给别人的",
          path: "/shareEwaybillToOthers",
          hideChildrenInMenu: true,
          routes: [
            {
              path: "/shareEwaybillToOthers/details/:id/:id2/:id3/:id4",
              name: "电子面单使用明细",
            },
            {
              path: "/shareEwaybillToOthers/details/exportEwaybillHistory",
              name: "导出记录",
            },
            {
              path: "/shareEwaybillToOthers/operationRecord/:id",
              name: "充值记录",
            },
          ],
        },
        {
          name: "别人共享给我的",
          path: "/shareEwaybillToMe",
          hideChildrenInMenu: true,
          routes: [
            {
              path: "/shareEwaybillToMe/details/:id/:id2/:id3",
              name: "电子面单使用明细",
            },
            {
              path: "/shareEwaybillToMe/details/exportEwaybillHistory",
              name: "导出记录",
            },
            {
              path: "/shareEwaybillToMe/operationRecord/:id",
              name: "充值记录",
            },
          ],
        },
        {
          name: "充值明细查询",
          routes: [
            {
              path: "/shareRechargeRecordDetail/consumer",
              name: "别人共享给我的",
            },
            {
              path: "/shareRechargeRecordDetail/provider",
              name: "我共享给别人的",
            },
          ],
        },
      ],
    },
    {
      path: "/ewaybillSearch",
      name: "单号查询",
      icon: <SearchOutlined />,
      isNew,
    },
    {
      path: "/WeChat/management",
      name: "微信子账号",
      icon: <TeamOutlined />,
      isNew,
      hideChildrenInMenu: true,
      routes: [
        {
          path: "/WeChat/management/add/inputName",
          name: "设置用户名",
        },
        {
          path: "/WeChat/management/add/scanCode",
          name: "微信扫码绑定",
        },
        {
          path: "/WeChat/management/add/finish",
          name: "绑定完成",
        },
      ],
    },
    {
      path: "/helper",
      name: "帮助中心",
      icon: <QuestionCircleOutlined />,
    },
  ],
};

const BasicLayout: React.FC<BasicLayoutProps> = function (props) {
  const location = useLocation();

  return (
    <AntBasicLayout
      logo={favicon}
      //   @ts-ignore
      title="电子面单共享平台"
      className="ec-basic-layout-container"
      fixSiderbar
      fixedHeader
      disableMobile
      layout="side"
      navTheme="light"
      location={location}
      route={route}
      headerTheme="light"
      headerHeight={64}
      headerRender={(props) => <Header collapsed={props.collapsed} onCollapse={props.onCollapse} />}
      //   headerRender={(props) => <Header collapsed={props.collapsed} onCollapse={props.onCollapse} />}
      collapsedButtonRender={false}
      menuItemRender={(menuItemProps, defaultDom) => {
        if (menuItemProps.isUrl || !menuItemProps.path || location.pathname === menuItemProps.path) {
          return (
            <>
              {defaultDom} {menuItemProps.isNew}
            </>
          );
        }

        return (
          <Link to={menuItemProps.path}>
            {defaultDom} {menuItemProps.isNew}
          </Link>
        );
      }}
      breadcrumbRender={(routers = []) => [
        {
          path: "/",
          breadcrumbName: "首页",
        },
        ...routers,
      ]}
      itemRender={(route, params, routes, paths) => {
        const first = routes.indexOf(route) === 0;

        return first ? (
          route.breadcrumbName
        ) : (
          <Link to={route.path}>
            <span>{route.breadcrumbName}</span>
          </Link>
        );
      }}
    >
      <PageContainer>{props.children}</PageContainer>
    </AntBasicLayout>
  );
};

export default React.memo(BasicLayout);
